import SliderImg1 from "../../Assets/img/main-swiper-1.png";
import SliderImg2 from "../../Assets/img/main-swiper-2.png";
import SliderImg3 from "../../Assets/img/main-swiper-3.png";
import SliderImg4 from "../../Assets/img/main-swiper-4.png";

import IP_1 from "../../Assets/img/IP/thum_1.png";
import IP_2 from "../../Assets/img/IP/thum_2.png";
import IP_3 from "../../Assets/img/IP/thum_3.png";
import IP_4 from "../../Assets/img/IP/thum_4.png";
import IP_5 from "../../Assets/img/IP/thum_5.png";
import IP_6 from "../../Assets/img/IP/thum_6.png";
import IP_7 from "../../Assets/img/IP/thum_7.png";

type ProductArrTypes = {
  src: string;
  alt: string;
  desc?: string;
};

export const swiperArr: Array<ProductArrTypes> = [
  {
    src: IP_1,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_2,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_3,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_4,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_5,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_6,
    alt: "제품디자인 이미지",
  },
  {
    src: IP_7,
    alt: "제품디자인 이미지",
  },
];
